import { useEffect, useRef, useState, type ReactNode } from "react";
import { participantSearchContext } from "./ParticipantSearchContext";

export const ParticipantSearchProvider = ({ children }: { children: ReactNode }) => {
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const inputRef = useRef<HTMLInputElement>(null);

    const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (timer.current) clearTimeout(timer.current);
        timer.current = setTimeout(() => {
            setDebouncedSearch(search);
        }, 200);
    }, [search]);

    return (
        <participantSearchContext.Provider value={{ search, setSearch, debouncedSearch, inputRef }}>
            {children}
        </participantSearchContext.Provider>
    );
};
